<template>
  <div class="main">
    <div v-if="tanks.length == 0">Aguardando dados...</div>
    
    <div v-else class="box">
      <div   v-for="(tank, i) in tanks" :key="i" 
            class="area-tank">
  
        <div>{{ tank.description }}</div>
        <div class="tank">
          <img src="@/assets/Fluxogramas/tanque_mel.png" alt="tank">
          <div class=area-bargraph>
            <span  class="bargraph2" :id="'tank-'+tank.id"></span>
            <span class="bargraph"></span>
          </div>
          <b-input class="input-pentagro" v-model="tank.value" type="number" step="0.5" min="0" max="100" @change="() => changeLeve(tank.value, tank.id)"></b-input>
        </div>
      </div>
    </div>
    <b-row class="groupBtn mr-1">
      <img
        class="float-right"
        src="@/assets/importardadosindicadores.png"
        style="margin-left: 16px;"
        title="Importar dados do tanque"
        alt="Importar dados do tanque"
        @click="importDataTank"
      />
      <img
        class="float-right"
        src="@/assets/assinarEconfirmar.png"
        style="margin-left: 16px;"
        title="Confirmar nível do tanque"
        alt="Confirmar nível do tanque"
        @click="activeOnline"
      />
      <img
        class="float-right"
        src="@/assets/sair.png"
        style="margin-left: 16px;"
        :title="$t('sair')"
        alt="Sair"
        @click="cancelSave"
      />
    </b-row>
  </div>
</template>

<script>
import { urlMainAPI, defaultSuccess } from "@/global";
import { WaitMixin } from "../mixins/waitMixin"
import axios from "axios";

  export default {
    name:"DynamicTankConfiguration",

    props: [ "eventCancel" ],

    mixins: [ WaitMixin, ],

    data() {
      return {
        xml: {},
        tanks: [],
        tankLevel: 0,
        onlineActive: false
      }
    },

    methods:{
      loadDynamicLevel(){
        const url = `${urlMainAPI}/loaddynamictankconfiguration`  
        axios.get(url)
        .then( res => {
          if(res.status == 200 && res.data.length > 0){
            this.tanks = new Array();
            res.data.forEach(tank => {
              let value = parseFloat(tank.value.replace(/,/, '.'))
              this.tanks.push({...tank, value: value})
              setTimeout(() => {this.loadTank(value, tank.id)}, 400) 
            });
          }
        }).catch(console.log)
      },

      changeLeve(valuePercent, id){
        let tank = this.tanks.find(t => t.id == id)
        tank.value = valuePercent = valuePercent > 100 ? 100 : valuePercent < 0 ? 0 : valuePercent
        this.loadTank(tank.value, id)
      },

      loadTank(valuePercent, id){
        const tank = document.getElementById(`tank-${id}`)

        if(tank){
          let value = 60 * (1 - (valuePercent / 100))
          tank.style.height = `${value}px`
        }
      },

      importDataTank(){
        defaultSuccess(this.$t('importando-dados-da-planta'))
        this.waitOn()
        const url = `${urlMainAPI}/importdynamictankvalue`  
        axios.get(url)
        .then( res => {
          if(res.status == 200 && res.data.length > 0){
            res.data.forEach(t1 => {
              let tank = this.tanks.find( t2 => t2.id== t1.id)
              tank.value = parseFloat(t1.value.replace(',', '.'))
              setTimeout(() => {this.loadTank(tank.value, tank.id)}, 400) 
            })
          }
          this.waitOff()
          defaultSuccess(this.$t('tanques-atualizados'))
        }).catch(err => {console.log(err); this.waitOff() })
      },

      activeOnline(){
        defaultSuccess(this.$t('ativando-o-modelo-de-simulacao'))
        this.waitOn()

        let simulationStructure = {
          "scenarioName": this.xml.name,
          "scenario": this.xml.scenario,
          "scenarioResult": this.xml.scenarioResult,
          "dynamicTank" : this.tanks.map(t => ({...t, value: t.value.toString().replace(".", ",")}))
        }

        this.$store.commit("setChangingStatus", 1);
        const url = `${urlMainAPI}/activateonlinesimulation`
        axios.post( url, simulationStructure).then((res) => {
              defaultSuccess(res.data);
              this.waitOff()
              this.$store.commit("setChangingStatus", 0);
              this.$store.commit("setIsOnlineRunning", true);
        }).catch(err => { console.log(err); this.waitOff() })

        this.onlineActive = true;
        this.waitOff()
        this.$bvModal.hide('dynamicTankConfiguration')
      },

      cancelSave(){
        this.$emit("eventCancel", false)
        this.waitOff()
        this.$bvModal.hide('dynamicTankConfiguration')
      }
    },

    mounted() {
      this.loadDynamicLevel()
      this.xml = JSON.parse(localStorage.xml)
    },

    destroyed() {
      this.waitOff()
      if(!this.onlineActive) this.$emit("eventCancel", false)
    },
  }
</script>

<style scoped>
.main{
  margin: 8px;
}

.box{
  border-radius: 8px;
  box-shadow: 0px 0px 4px #0005;
  transition-duration: 400ms;
}

.area-tank{
  padding: 0px 16px;
  height: 95px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tank{
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tank>img{
  height: 75px;
}

.tank>input{
  width: px;
  height: 30px;
  text-align: right;
  border: #ff5f00 solid 1px;
}

.tank>input:focus{
  box-shadow: 0px 0px 5px #ff5f00;
}

.area-bargraph{
  position: relative;
}
.area-bargraph, .bargraph, .bargraph2{
  width: 14px;
  height: 60px;
}

.bargraph, .bargraph2{
  position: absolute;
  top: 1px;
  right: 78px;
  width: 14px;
  border-radius: 3px;
}

.bargraph{
  background-color: #ff5f00;
}

.bargraph2{
  background-color: #777;
  z-index: 1;
  transition-duration: 1000ms;
}

.groupBtn{
  margin-top: 24px;
  border-top: 1px solid #0002;
}

.groupBtn>img{
  padding-top: 8px;
}


</style>